'use strict'

import React from 'react';
import request from 'superagent';
import uuid from 'uuid';

import AreaForm from '../components/AreaForm.jsx';
import ProjectMenu from '../components/ProjectMenu.jsx';
import Layout from '../Layout.jsx';
import FormattedContent from '../components/FormattedContent.jsx';

import sendCommand from '../../app/utils/sendCommand.js';

import formDefinition from './formDefinition.js';

import Translations from '../../app/utils/translations.js';

let translations=new Translations([
    require('./labels/english.js'),
    require('./labels/norwegian.js')
]);

class OutputSummarySimple extends React.Component {
  render() {
    return (
      <div>
        <b>{this.props.scopeEntry.text}</b><br/>
        <FormattedContent value={this.props.output}/><br/>
        <i><FormattedContent value={this.props.qualityExpectation}/></i>
        <table>
          <tbody>
            <tr>
              <td><FormattedContent value={this.props.acceptanceCriteria}/></td>
              <td><FormattedContent value={this.props.acceptanceMethod}/></td>
              <td><FormattedContent value={this.props.acceptanceResponsible}/></td>
            </tr>
          </tbody>
        </table>

      </div>
    )
  }
}

class FieldValue extends React.Component {
  render() {
    return (
      <span>
        <div style={{display:"flex", alignItems:"center"}}>
          {this.props.value===undefined || this.props.value.trim().length===0 ? (
            <span style={{color:"lightgrey"}}>""</span>
          ) : (
            <div style={{fontFamily:"Arial, Verdana, Geneva, sans-serif"}}>
              <FormattedContent value={this.props.value}/>
            </div>
          )}
          <div style={{fontFamily: "Times", paddingLeft: 10, textTransform:"lowerCase", color:"lightgrey"}}>({this.props.name})</div>
        </div>
      </span>

    );
  }
}

class Label extends React.Component {
  render() {
    return (
      <span style={{fontStyle:"italic", color:"grey"}}>{this.props.label}</span>
    )
  }
}

class FieldWithLabel extends React.Component {
  render() {
    return (
      <div style={{paddingBottom: 5}}>
        <div>
          <Label {...this.props}/>
        </div>
        <div style={{paddingLeft:20}}>
          <FieldValue {...this.props}/>
        </div>
      </div>
    )
  }
}

class InlineFieldLabel extends React.Component {
  render() {
    return (
      <div style={{paddingBottom: 5}}>
        <div>
          <FieldValue value={this.props.inlineValue} name={this.props.inlineName}/>
          <span> </span>
          <Label {...this.props}/>
        </div>
        <div style={{paddingLeft:20}}>
          <FieldValue {...this.props}/>
        </div>
      </div>
    )
  }
}

class OutputSummaryAssisted extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props);
    let labelsText=labels.outputSummary;
    return (
      <div className="outputSummary" style={{fontSize: "80%"}}>
        <FieldWithLabel
          label={labelsText.cover}
          value={this.props.scopeEntry.text}
          name={labels.general.scope}
        />
        <FieldWithLabel
          label={labelsText.projectWillDeliver}
          value={this.props.output}
          name={labels.output.fields.output.title}
        />
        <FieldWithLabel
          label={labelsText.theReceiverWants}
          value={this.props.qualityExpectation}
          name={labels.output.fields.qualityExpectation.title}
        />
        <InlineFieldLabel
          inlineValue={this.props.acceptanceResponsible}
          inlineName={labels.acceptance.fields.acceptanceResponsible.title}
          label={labelsText.willConfirm}
          value={this.props.acceptanceCriteria}
          name={labels.acceptance.fields.acceptanceCriteria.title}
        />
        <FieldWithLabel
          label={labelsText.by}
          value={this.props.acceptanceMethod}
          name={labels.acceptance.fields.acceptanceMethod.title}
        />
      </div>
    )
  }
}

class OutputSummary extends React.Component {
  render() {
    return false ? (
      <OutputSummarySimple {...this.props}/>
    ) : (
      <OutputSummaryAssisted {...this.props}/>
    );
  }
}

export class ProjectProductDescription extends React.Component {
  constructor(props) {
    super(props);
    let labels=translations.getTranslation(props.language);
    var selected=0;
    if (typeof window!=="undefined" && window.location.hash.length>0) {
      formDefinition.forEach((area,index) =>{
        if (area.name===window.location.hash.slice(1)) {
          selected=index;
        }
      })
    }
    let quality=Object.assign({},props.quality,{
        id: this.props.project.qualityApproach!==undefined ? "savedApproach" : undefined,
        _progress: "qualityManagementApproach"//"qualityRegister",
      },
      this.props.project.qualityApproach
    );
    this.state={
      quality: quality,
      lastSaved: quality,
      selected: selected
    };
    this.warningOnLeave=this.changeWarningOnLeave.bind(this)
  }

  update(approach) {
    let strippedApproach=Object.assign({},approach,{id:undefined,scopeDetails:undefined,_progress:undefined});
    sendCommand({type:"updateQualityManagementApproach", project:{id:this.props.project.id}, approach:strippedApproach})
      .then(response=>{
        let updatedQuality=Object.assign({},this.state.quality, response.approach,{
          _currentProgress: approach._progress,
          id: "savedApproach"
        });
        this.setState({
          quality: updatedQuality,
          modified: undefined,
          lastSaved: updatedQuality
        });
      })
      .catch(error=>{
        console.log("Got error "+JSON.stringify(error),error);
        alert("Error saving approach");
      })
  }

  handleFieldChange(fieldName) {
    return (event)=>{
      if (event.details!==undefined && event.details.action==="prioritize") {
        let id=event.target.name.split(".")[1];
        sendCommand({type:"prioritizeOutput", project: {id:this.props.project.id}, parent:id,item:{id: event.details. item}, position: event.details.position})
          .then(response=>{
            this.setState({
              quality:Object.assign({},this.state.quality,{scopeDetails:response.quality}),
              lastSaved: Object.assign({},this.state.quality,{scopeDetails:response.quality}),
              details:undefined,
              modified:true});
          })
          .catch(error=>alert("Not able to prioritize output, "+JSON.stringify(error)));
      } else {
        this.setState({
          quality:Object.assign({},this.state.quality,{
            [event.target.name]:event.target.value
          }),
          modified:true
        });
      }
    };
  }

  hasChanged(lastSaved) {
    return formDefinition.map(area=>
      area.fields!==undefined && area.fields.map(field=>
        JSON.stringify(lastSaved[field.name])!==JSON.stringify(this.state.quality[field.name])
      )
      .reduce((value,result)=>result || value)
    ).reduce((value,result)=>result || value);
  }

  changeWarningOnLeave(e) {
    if (this.hasChanged(this.state.lastSaved)) {
      e.returnValue="Do you want to keep changes?";
      return "Do you want to keep changes?";
    }
  }

  componentDidMount() {
    window.addEventListener("beforeunload", this.warningOnLeave);
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload",this.warningOnLeave);
  }

  showDetails(details) {
    this.setState({details:details});
  }

  updateDetails(content) {
    if (this.state.details.type==="multiTable") {
      let field=this.state.details.field.split(".");
      if (content.id!==undefined) {
        let quality=Object.assign({},this.state.quality,{
          [field[0]]:this.state.quality[field[0]].map(entry=>
            entry.id===field[1]
              ? Object.assign({},entry,{
                  items: entry.items.map(item=>
                    item.id===content.id ? Object.assign({},item,content,{_progress: "dependencies"}) : item
                  )
                })
              : entry
          )
        });
        let updatedEntry=quality[field[0]].filter(entry=>entry.id===field[1])[0].items.filter(item=>item.id===content.id)[0];
        sendCommand({type:"updateOutput",project: {id:this.props.project.id}, parent:field[1],item:updatedEntry})
          .then((response)=>{
            this.setState({
              quality:Object.assign({},this.state.quality,{scopeDetails:response.quality}),
              lastSaved: Object.assign({},this.state.quality,{scopeDetails:response.quality}),
              details:undefined,
              modified:false});
          })
          .catch((error)=>{
            alert("Could not save output"+JSON.stringify(error));
          })
      } else {
        let newOutput=Object.assign({},content,{id:uuid.v4(), _progress: "dependencies"});
        let quality=Object.assign({},this.state.quality,{
          [field[0]]:this.state.quality[field[0]].map(entry=>
            entry.id===field[1]
              ? Object.assign({},entry,{
                  items: (entry.items!==undefined ? entry.items : []).concat(newOutput)
                })
              : entry
          )
        });
        sendCommand({type:"addOutput",project: {id:this.props.project.id}, parent:field[1],item:newOutput})
          .then((response)=>{
            this.setState({
              quality:Object.assign({},this.state.quality,{scopeDetails:response.quality}),
              lastSaved: Object.assign({},this.state.quality,{scopeDetails:response.quality}),
              details:undefined,
              modified:false}
            );
          })
          .catch((error)=>{
            alert("Could not save output"+JSON.stringify(error));
          })
      }
    } else {
      if (content.id!==undefined) {
        let quality=Object.assign({},this.state.quality,{
          [this.state.details.field]:this.state.quality[this.state.details.field].map(item=>
            item.id===content.id ? Object.assign({},item,content,{_progress: "dependencies"}) : item
          )
        });
        this.setState({quality:quality, details:undefined, modified:true});
      } else {
        let quality=Object.assign({},this.state.quality,{
          [this.state.details.field]:this.state.quality[this.state.details.field].concat(
            Object.assign({},content,{id:uuid.v4(), _progress: "dependencies"})
          )
        });
        this.setState({quality:quality, details:undefined, modified:true});
      }
    }
  }

  canceledDetails() {
    this.setState({details:undefined});
  }

  deleteOutput(item) {
    let field=this.state.details.field.split(".");
    sendCommand({type:"deleteOutput",project: {id:this.props.project.id}, parent:field[1], item:{id: item.id}})
      .then((response)=>{
        this.setState({
          quality:Object.assign({},this.state.quality,{scopeDetails:response.quality}),
          lastSaved: Object.assign({},this.state.quality,{scopeDetails:response.quality}),
          details:undefined,
          modified:false});
      })
      .catch((error)=>{
        alert("Could not delete output"+JSON.stringify(error));
      })
  }

  showOutputSummary(tab,details) {
    return (
      <OutputSummary
        {...this.props}
        {...details.values}
        scopeEntry={this.state.quality.scopeDetails.filter(entry=>
          entry.id===this.state.details.field.split(".")[1]
        )[0]
      }/>
    );
  }

  handleOutputFieldChange(fieldName) {
    return (event)=>{
      let updatedDetails=Object.assign({},this.state.details,{
        item:Object.assign({},this.state.details.item,{
          [fieldName]:event.target.value
        })
      });
      this.setState({
        details: updatedDetails
      });
    };
  }

  render() {
    let labels=translations.getTranslation(this.props);
    let areas=translations.createTranslatedForm(formDefinition,this.props.language,this.props.variant)
      .filter(area=>area.name==="projectProductDescription" || this.props.showApproach);

    return (
      <div style={{marginTop: 20, display:"flex", justifyContent:"center", flexWarp:"wrap"}}>
        <div style={{width:1016, paddingBottom:30}}>
          {this.state.details!==undefined ? (
            <AreaForm key="details"
              {...this.props}
              display="tab"
              areas={translations.createTranslatedForm(this.state.details.form,this.props.language,this.props.variant)}
              item={this.state.details.item}
              selected={0}
              label={labels.general.output}
              onUpdate={this.updateDetails.bind(this)}
              modified={true}
              onCancel={this.canceledDetails.bind(this)}
              summary={this.showOutputSummary.bind(this)}
              handleFieldChange={this.handleOutputFieldChange.bind(this)}
              onDelete={this.deleteOutput.bind(this)}
            />

          ) : (
          <AreaForm key="quality"
            {...this.props}
            display={this.props.editOutput ? "normal" : "tab"}
            areas={areas}
            item={this.state.quality}
            label={labels.general.approach}
            selected={this.state.selected}
            onUpdate={this.update.bind(this)}
            modified={this.state.modified}
            handleFieldChange={this.handleFieldChange.bind(this)}
            onCancel={()=>window.location="."}
            summary={(tab)=><i>{labels[tab].description}</i>}
            onAddEntry={this.showDetails.bind(this)}
            onEditEntry={this.showDetails.bind(this)}
          />
          )}
        </div>
      </div>
    );
  }
}

export default class ProjectProductDescriptionPage extends React.Component {
  render() {
    var menu=(this.props.showMenu===true) ? <ProjectMenu {...this.props}/> : undefined;
    return (
      <Layout {...this.props} projectMenu={menu}>
        <ProjectProductDescription {...this.props}/>
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./views/quality/ProjectProductDescription.jsx